export class BureauPreferentielOccupationDto {
	journeeOccupee: Date;
	estReserveParAutreOccupant: string;

	constructor(journeeOccupee: Date, estReserveParAutreOccupant: string) {
		this.journeeOccupee = journeeOccupee;
		this.estReserveParAutreOccupant = estReserveParAutreOccupant;
	}
}
